import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "fill", "stroke", "stroke-width"]


export default /*@__PURE__*/_defineComponent({
  __name: 'CaretLeft',
  props: {
  width: {
    type: [String, Number],
    default: 16,
  },
  height: {
    type: [String, Number],
    default: 16,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
  stroke: {
    type: String,
    default: 'currentColor',
  },
  strokeWidth: {
    type: [String, Number],
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, _ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    fill: __props.fill,
    stroke: __props.stroke,
    "stroke-width": __props.strokeWidth
  }), [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }, null, -1)
  ]))], 16, _hoisted_1))
}
}

})